import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Paper,
  Collapse,
  IconButton,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const chipPrimary = {
  backgroundColor: "#fff8dc",
  color: "#b45309",
  border: "1px solid #facc15",
  fontWeight: 500,
};

const chipSecondary = {
  backgroundColor: "#fff1cc",
  color: "#92400e",
  border: "1px solid #f59e0b",
  fontWeight: 500,
};

const chipNeutral = {
  backgroundColor: "#f9fafb",
  color: "#374151",
  border: "1px solid #e5e7eb",
  fontWeight: 500,
};

const ScoringRubric = () => {
  const [open, setOpen] = useState(false);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        borderRadius: 2,
        mb: 2,
        border: "1px solid #facc15",
        backgroundColor: "#fffef7",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InfoOutlinedIcon sx={{ color: "#f59e0b" }} />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "#92400e" }}
          >
            How scoring works
          </Typography>
        </Box>

        <IconButton size="small" sx={{ color: "#b45309" }}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {/* Content */}
      <Collapse in={open}>
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ mb: 1.5, color: "#6b7280" }}>
            Harder pages earn more points. Fast submissions still count, but
            only for half points and may be flagged for attention.
          </Typography>

          {/* Main scoring */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.25 }}>
            <Chip
              label="Printed transcription = 4 points"
              size="small"
              sx={chipPrimary}
            />
            <Chip
              label="Handwritten transcription = 6 points"
              size="small"
              sx={chipPrimary}
            />
            <Chip
              label="Printed review = 2 points"
              size="small"
              sx={chipSecondary}
            />
            <Chip
              label="Handwritten review = 3 points"
              size="small"
              sx={chipSecondary}
            />
          </Box>

          <Typography variant="body2" sx={{ mb: 1, color: "#6b7280" }}>
            Fast work receives half points:
          </Typography>

          {/* Fast scoring */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1.25 }}>
            <Chip
              label="Printed transcription fast = 2 points"
              size="small"
              sx={chipNeutral}
            />
            <Chip
              label="Handwritten transcription fast = 3 points"
              size="small"
              sx={chipNeutral}
            />
            <Chip
              label="Printed review fast = 1 point"
              size="small"
              sx={chipNeutral}
            />
            <Chip
              label="Handwritten review fast = 1.5 points"
              size="small"
              sx={chipNeutral}
            />
          </Box>

          <Typography variant="body2" sx={{ color: "#6b7280" }}>
            Ranking is based on score, then transcription count, then review
            count, then total time spent.
          </Typography>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default ScoringRubric;
